import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface AlertFilledProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const AlertFilled = forwardRef<SVGSVGElement, AlertFilledProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <path
          fill={primaryColor ?? colors.warning20}
          fillRule='evenodd'
          d='M12 22.004c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10'
          clipRule='evenodd'
        ></path>
        <path
          fill={secondaryColor ?? '#6B4E11'}
          fillRule='evenodd'
          d='M13.5 7.231a1.25 1.25 0 1 0-2.5 0v5.822a1.25 1.25 0 1 0 2.5 0zm-1.22 10.796a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5'
          clipRule='evenodd'
        ></path>
      </svg>
    );
  }
);

AlertFilled.displayName = 'AlertFilled';

export default AlertFilled;
